import { Component, Input, OnInit } from '@angular/core';
import { StatusConfigKey } from './enums/status-config-key.enum';
import { ALL_STATUS_CONFIGS_KEYS, STATUS_CONFIG_KEY_TO_STATUSES, STATUS_CONFIG_KEY_CONFIG } from './constants/status-config.constants';
import { StatusAggregation } from './models/status-aggregation.model';

@Component({
    selector: 'edl-status-aggregation-indicator',
    templateUrl: './status-aggregation-indicator.component.html',
    styleUrls: ['./status-aggregation-indicator.component.scss']
})
export class StatusAggregationIndicatorComponent implements OnInit {
    @Input() userStatusCounts: { [key: number]: number } = {};
    @Input() activeColumns: StatusConfigKey[] = [];

    statusAggregations: StatusAggregation[] = [];

    private static readonly configByKey = new Map(
        STATUS_CONFIG_KEY_CONFIG.map(cfg => [cfg.key, cfg])
    );

    ngOnInit() {
        this.buildStatusAggregations();
    }

    private buildStatusAggregations() {
        const configKeyCounts = this.getStatusConfigCounts(this.userStatusCounts ?? {});

        if (this.activeColumns && this.activeColumns.length > 0) {
            // Spacer mode: render all active columns with invisible placeholders for missing statuses
            this.statusAggregations = this.activeColumns.map(key => {
                const config = StatusAggregationIndicatorComponent.configByKey.get(key);
                const count = configKeyCounts[key] ?? 0;
                return {
                    ...config,
                    count: count,
                    visible: count > 0
                };
            });
        } else {
            // Legacy mode: only show statuses with counts > 0
            this.statusAggregations = STATUS_CONFIG_KEY_CONFIG
                .map(cfg => ({ ...cfg, count: configKeyCounts[cfg.key] ?? 0, visible: true }))
                .filter(agg => agg.count > 0);
        }
    }

    private getStatusConfigCounts(userStatusCounts: { [key: number]: number }): { [key in StatusConfigKey]: number } {
        return ALL_STATUS_CONFIGS_KEYS.reduce((acc, key) => {
            acc[key] = STATUS_CONFIG_KEY_TO_STATUSES[key].reduce((sum, status) => sum + (userStatusCounts[status] ?? 0), 0);
            return acc;
        }, {} as { [key in StatusConfigKey]: number });
    }

    getDisplayCount(count: number): string {
        return count > 9 ? '9+' : count.toString();
    }
}